import { combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromAnyObject from './any-object.reducer';
import * as fromCommonObjectList from './common-object-list.reducer';

export interface State {
	userData: fromAnyObject.AnyObjectState;
	portfolios: fromCommonObjectList.CommonObjectListState;
	modelPortfolios: fromAnyObject.AnyObjectState;
	selectedUniqueId: fromAnyObject.AnyObjectState;
	singlePortfolioVisible: fromAnyObject.AnyObjectState;
}

export const StateNames = {
	userData: 'userData',
	portfolios: 'portfolios',
	modelPortfolios: 'modelPortfolios',
	selectedUniqueId: 'selectedUniqueId',
	singlePortfolioVisible: 'singlePortfolioVisible'
};

export function getInitialState(): any {
	return {
		userData: fromAnyObject.initialState,
		portfolios: fromCommonObjectList.initialState,
		modelPortfolios: fromAnyObject.initialState,
		selectedUniqueId: fromAnyObject.initialState,
		singlePortfolioVisible: fromAnyObject.initialState
	};
}

export const reducers = combineReducers({
	userData: fromAnyObject.createReducerWithName(StateNames.userData),
	portfolios: fromCommonObjectList.createReducerWithName(StateNames.portfolios),
	modelPortfolios: fromAnyObject.createReducerWithName(StateNames.modelPortfolios),
	selectedUniqueId: fromAnyObject.createReducerWithName(StateNames.selectedUniqueId),
	singlePortfolioVisible: fromAnyObject.createReducerWithName(StateNames.singlePortfolioVisible)
});

export const getState = createFeatureSelector<State>('bfa');

// get portfolios
export const getPortfoliosState = createSelector(getState, state => state.portfolios);

export const getPortfolios = createSelector(getPortfoliosState, fromCommonObjectList.getCommonObjectList);

export const getModelPortfoliosState = createSelector(getState, state => state.modelPortfolios);

export const getModelPortfolios = createSelector(getModelPortfoliosState, fromAnyObject.getObject);

export const getSelectedUniqueIdState = createSelector(getState, state => state.selectedUniqueId);

export const getSelectedPortfolioId = createSelector(getSelectedUniqueIdState, fromAnyObject.getObject);

// get user data
export const getUserDataState = createSelector(getState, state => state.userData);

export const getUserData = createSelector(getUserDataState, fromAnyObject.getObject);

// get SinglePortfolioVisible
export const getSinglePortfolioVisibleState = createSelector(getState, state => state.singlePortfolioVisible);

export const getSinglePortfolioVisible = createSelector(getSinglePortfolioVisibleState, fromAnyObject.getObject);
